var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3029 3.82811L15.594 4.11111H16H18.8571C18.9025 4.11111 18.9405 4.12848 18.9672 4.15449C18.9936 4.18012 19 4.20421 19 4.22222C19 4.24023 18.9936 4.26433 18.9672 4.28995C18.9405 4.31596 18.9025 4.33333 18.8571 4.33333H5.14286C5.09753 4.33333 5.05955 4.31596 5.03279 4.28995C5.00644 4.26432 5 4.24023 5 4.22222C5 4.20421 5.00644 4.18012 5.03279 4.1545C5.05955 4.12848 5.09753 4.11111 5.14286 4.11111H8H8.40599L8.69708 3.82811L9.50851 3.03922L8.81143 2.32222L9.50851 3.03922C9.51326 3.0346 9.52795 3.02294 9.5526 3.01295C9.57698 3.00308 9.5984 3 9.61143 3H14.3886C14.4016 3 14.423 3.00308 14.4474 3.01295C14.4721 3.02294 14.4867 3.0346 14.4915 3.03922L15.1886 2.32222L14.4915 3.03922L15.3029 3.82811ZM7.42854 20.9999C6.69694 20.9999 6.14283 20.4212 6.14283 19.7777V8.66656C6.14283 8.02299 6.69694 7.44434 7.42854 7.44434H16.5714C17.303 7.44434 17.8571 8.02299 17.8571 8.66656V19.7777C17.8571 20.4212 17.303 20.9999 16.5714 20.9999H7.42854Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3918f830721c82565845981b84551c5f.svg";
export { ForwardRef as ReactComponent };